module.exports = __webpack_public_path__ + "img/WarDirigible.41af8cc7.jpg";